import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';

import {Timer} from './TimerTypes';

const TimerActions = {
  updateTimer(timerId: string, options: Partial<Timer>): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.TIMER_UPDATE,
      timerId,
      options,
    });
  },

  removeTimer(timerId: string): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.TIMER_REMOVE,
      timerId,
    });
  },
};

export default TimerActions;
